export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (process.client) {
    const metaTag = document.querySelector('meta[name="git-sha"]');
    if (!metaTag) {
      const meta = document.createElement('meta');
      meta.name = 'git-sha';
      meta.content = config.public.gitSha;
      document.head.appendChild(meta);
    } else {
      metaTag.setAttribute('content', config.public.gitSha);
    }
  }
});
